/* eslint-disable eqeqeq */
import React from 'react';
import ReactDOM from 'react-dom';
import {
  Spin
} from 'antd';
import "../node_modules/slick-carousel/slick/slick.css";
import "../node_modules/slick-carousel/slick/slick-theme.css";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/es/integration/react';
import App from './App.js';
import configureStore from './redux/store/configureStore.js'
import * as serviceWorker from './serviceWorker';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"


const { persistor, store } = configureStore();

const onBeforeLift = (store) => {
}


ReactDOM.render(
  <Provider store={store}>
    <PersistGate
      loading={<Spin size="large" />}
      onBeforeLift={onBeforeLift}
      persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
  , document.getElementById('root'));

serviceWorker.register();

